<template>
    <div>
        <buttonlist @help="help"@add="add" @search="search" @reflash="reflash" @del="delall" @exps="exp" ref="SetBtn"></buttonlist>
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                @selection-change="handleSelectionChange"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="PartCode" :label="$t('getapi[12424]')"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="Remark" :label="$t('getapi[143]')"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="Create_Person" :label="$t('getapi[410]')"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="Create_Time" :label="$t('getapi[2950]')"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
            <el-table-column show-overflow-tooltip sortable prop="Modify_Time" :label="$t('getapi[1210]')"></el-table-column>
            <el-table-column fixed="right" :label="$t('getapi[6048]')" width="80">
                <template slot-scope="scope">
                    <el-button :disabled="!btn.edit" @click.native.prevent="edit(scope)" type="text" size="small">{{ $t('getapi[34]') }}</el-button>
                    <el-popconfirm
                            :confirmButtonText="$t('getapi[6109]')"
                            :cancelButtonText="$t('getapi[6]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[637]')"
                            @onConfirm="del(scope)"
                    >
                        <el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-row class="page">
            <el-col :span="12">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[50, 100, 200, 300, 400]"
                        :page-size="PageSize"
                        :pager-count="5"
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
        </el-row>
        <el-dialog v-dialogDrag :visible.sync="editvisi" :title="$t('getapi[12416]')" width="30%" :close-on-click-modal="false">
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[12424]')}}</td>
                        <td><el-input v-model="formInline.PartCode" type="text" size="mini"></el-input></td>
                        <td>{{$t('getapi[143]')}}</td>
                        <td><el-input v-model="formInline.Remark" type="text"></el-input></td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>

            <span slot="footer" class="dialog-footer">
				<el-button  size="small" @click="editvisi = false">{{ $t('getapi[6]') }}</el-button>
				<el-button  size="small" type="primary" @click="sava" :loading="loading" :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
        <serce :isVisible="isVisible" queryData="SalDiscountOldpartViewInfo" ref="ser" @getser="serclick"></serce>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    export default {
        name: '3_saldiscountoldpart',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet:[],
                formInline: {
                    Exclusively_ID: '',
                    PartCode: '',
                    Remark: '',
                    Create_Person: '',
                    Create_Time: '',
                    Modify_Person: '',
                    Modify_Time: '',
                    LangType: '',
                    IsEdit: ''
                },
                showloading: '',
                queryData: [], // 查询数组
                loading: false,
                isVisible: false,
                editvisi: false,
                userData: [], // 用户信息
                DbTbNames: '',
                PageIndex: 1, // 当前页
                PageSize: this.$http.getPageSize('saldiscountoldpart'), // 当前页数据量
                SelectIndexs: 1,
                total: 0, // 数据总量
                btn: {
                    del: true,
                    edit: true
                },
                selectIDData:'',
                scrollTop:0,
            };
        },
        create() {},
        beforeMount() {
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12416]"),this.$t("getapi[3846]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('create,search,del,refresh,export');
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.getView();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.getView();
                this.authority();
            },
            // 获取数据
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Sal/SalDiscount/GetSal_Discount_OldpartView', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                        that.$nextTick(function(){
                            that.$processdata.initForm(0)
                        });
                    }
                });
            },
            // 保存数据
            sava() {
                let that = this;
                that.loading = true;
                let parm = that.formInline
                that.$http.urlpost('/Sal/SalDiscount/SaveSal_Discount_Oldpart', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.editvisi = false;
                        that.getView();
                    }
                    that.loading = false;
                });
            },
            // 编辑
            edit(row) {
                let that = this
                this.editvisi = true;
                this.formInline = {
                    Exclusively_ID: row.row.Exclusively_ID,
                    PartCode: row.row.PartCode,
                    Remark: row.row.Remark,
                    Create_Person: row.row.Create_Person,
                    Create_Time: row.row.Create_Time,
                    Modify_Person: row.row.Modify_Person,
                    Modify_Time: row.row.Modify_Time,
                    LangType: row.row.LangType,
                    IsEdit: 1
                }
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].Exclusively_ID + ',';
                }
            },
            // 删除
            del(jsd) {
                this.ids = jsd.row.Exclusively_ID + ',';
                this.delf();
            },
            //批量删除
            delall() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {});
            },
            delf() {
                let that = this;
                let parm = {
                    ids: that.ids
                };
                that.$http.urlpost('/Sal/SalDiscount/DeleteSal_Discount_OldpartByID', parm, function(res) {
                    if(res.Success == 1){
                        that.getView();
                        that.$message.success(that.$t('getapi[659]'));
                    }
                });
            },
            // 新增
            add() {
                let that = this
                this.formInline = {
                    Exclusively_ID: '',
                    PartCode: '',
                    Remark: '',
                    Create_Person: '',
                    Create_Time: '',
                    Modify_Person: '',
                    Modify_Time: '',
                    LangType: that.$processdata.getLang(),
                    IsEdit: 0
                }
                this.editvisi = true;
            },
            // 查询
            search() {
                let that = this
                this.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'SalDiscountOldpartViewInfo');
            },
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            confirmGetView() {
                let that = this;
                that.PageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 刷新
            reflash() {
                this.getView();
                this.authority();
            },
            exp(){
                let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: [],
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[12416]')
                };
                that.queryData.forEach(item => {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                that.$http.urlpost('/Sal/SalDiscount/SalDiscountOldpartTabExportToExecl', parm, function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
        }
    };
</script>

<style lang="scss" scoped>

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none;
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none;
    }

    .el-table .hidden-row {
        display: none;
    }
</style>
